import React, { Component, Fragment } from "react";
import { Col, Row } from 'reactstrap';
import { withStyles } from "@material-ui/core/styles";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';


/** 
 * 
 * family: {
 * enfermedad_coronaria: {
            value: "No",
            comentario: ""
          }
          diabetes: {
            value: "No",
            comentario: ""
          },
          cancer: {
            value: "No",
            comentario: ""
          },
          
          hipertension: {
            value: "No",
            comentario: ""
          },
          muerte_subita: {
            value: "No",
            comentario: ""
          },
          
        }
 * 
*/

const MedicalRadio = withStyles({
    root: {
        color: '#4CE1B6',
        '&$checked': {
            color: '#4CE1B6',
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

class Family extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Fragment>
                <Row>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black', position: 'absolute', width: '200px' }} disabled={true}>Enfermedad Coronaria</FormLabel>
                                    <FormLabel style={{ color: 'black' }} disabled={true}>&nbsp;</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerFamilyBackgroundRadio(e.target.value, 'enfermedad_coronaria');
                                        }}
                                        row aria-label="position"
                                        id="radio-family-enfermedad_coronaria"
                                        name="radio-family-enfermedad_coronaria"
                                        value={this.props.sectionAilment.family.enfermedad_coronaria.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.family.enfermedad_coronaria.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.family.enfermedad_coronaria.comentario}
                                    onChange={(e) => {
                                        this.props.handlerFamilyBackgroundText(e.target.value, 'enfermedad_coronaria');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Diabetes</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerFamilyBackgroundRadio(e.target.value, 'diabetes');
                                        }}
                                        row aria-label="position"
                                        id="radio-family-diabetes"
                                        name="radio-family-diabetes"
                                        value={this.props.sectionAilment.family.diabetes.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.family.diabetes.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.family.diabetes.comentario}
                                    onChange={(e) => {
                                        this.props.handlerFamilyBackgroundText(e.target.value, 'diabetes');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Cancer</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerFamilyBackgroundRadio(e.target.value, 'cancer');
                                        }}
                                        row aria-label="position"
                                        id="radio-family-cancer"
                                        name="radio-family-cancer"
                                        value={this.props.sectionAilment.family.cancer.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.family.cancer.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.family.cancer.comentario}
                                    onChange={(e) => {
                                        this.props.handlerFamilyBackgroundText(e.target.value, 'cancer');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Hipertensión</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerFamilyBackgroundRadio(e.target.value, 'hipertension');
                                        }}
                                        row aria-label="position"
                                        id="radio-family-hipertension"
                                        name="radio-family-hipertension"
                                        value={this.props.sectionAilment.family.hipertension.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.family.hipertension.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.family.hipertension.comentario}
                                    onChange={(e) => {
                                        this.props.handlerFamilyBackgroundText(e.target.value, 'hipertension');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black', position: 'absolute', width: '250px' }} disabled={true}>{'Muerte Subita(H<55/M<60)'}</FormLabel>
                                    <FormLabel style={{ color: 'black' }} disabled={true}>&nbsp;</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerFamilyBackgroundRadio(e.target.value, 'muerte_subita');
                                        }}
                                        row aria-label="position"
                                        id="radio-family-muerte_subita"
                                        name="radio-family-muerte_subita"
                                        value={this.props.sectionAilment.family.muerte_subita.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.family.muerte_subita.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.family.muerte_subita.comentario}
                                    onChange={(e) => {
                                        this.props.handlerFamilyBackgroundText(e.target.value, 'muerte_subita');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <div className="form">
                        <span className="form__form-group-label" style={{ marginRight: 10, width: 150 }}>Observaciones</span>
                        <div className="form__form-group-field">
                            <textarea
                                id="textarea-observation"
                                value={this.props.sectionAilment.family.observacion}
                                disabled={this.props.stateClinicHistory}
                                name="textarea-surgical"
                                onChange={(e) => {
                                    this.props.handlerFamilyBackgroundObservation(e.target.value, 'observacion');
                                }}
                            >
                            </textarea>
                        </div>
                    </div>
                </Row>
            </Fragment>

        );
    }
}

export default Family;
